import { render, staticRenderFns } from "./AppLayoutMainArea.vue?vue&type=template&id=2c9e6f75&scoped=true&"
import script from "./AppLayoutMainArea.vue?vue&type=script&lang=js&"
export * from "./AppLayoutMainArea.vue?vue&type=script&lang=js&"
import style0 from "./AppLayoutMainArea.vue?vue&type=style&index=0&id=2c9e6f75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c9e6f75",
  null
  
)

export default component.exports